export const BUCKET_NAME = 'axn-lang';